import styled, { css } from 'styled-components';
import SVG from 'react-inlinesvg';
import { buttonReset } from '../../styled/buttons';

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`;

export const Button = styled.button`
  ${buttonReset};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme, disabled }) => disabled && theme.palette.disabled};

  // accessibility - minimum tap target = 44px
  width: 44px;
  height: 44px;

  &:focus,
  &:hover {
    color: ${({ theme, disabled }) => !disabled && theme.palette.primaryLink};
  }
`;

export const ButtonSVG = styled(SVG)`
  display: block;
  width: 1em;
  height: 1em;
  overflow: visible;
`;

export const SlideMask = styled.div``;

export const SlideCarouselInner = styled.div``;

export const SlideCarouselOuter = styled.div`
  overflow: hidden;

  ${({ $numSlides, $current }) => css`
    ${SlideCarouselInner} {
      width: ${100 * $numSlides}%;
    }

    ${SlideMask} {
      display: flex;
      width: ${100 / $numSlides}%;
      margin-left: -${(100 / $numSlides) * $current}%;
      transition: margin 200ms ease-out;

      > div {
        flex: 0 0 100%;
      }
    }
  `}
`;
